// Minimal WP REST client helpers for same-origin WordPress + ReactPress

export async function getNonce() {
  const r = await fetch('/wp-json/grade/v1/nonce', { credentials: 'include',   headers: { 'X-WP-Nonce': window.wpApiSettings?.nonce } });
  if (!r.ok) throw new Error(`Nonce HTTP ${r.status}`);
  const { nonce } = await r.json();
  if (!nonce) throw new Error('Nonce missing in response');
  return nonce;
}

export async function fetchJSON(path, { method = 'GET', body, nonce } = {}) {
  const headers = { 'Content-Type': 'application/json' };
  if (nonce) headers['X-WP-Nonce'] = nonce;

  const r = await fetch(path, {
    method,
    credentials: 'include',
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });

  if (!r.ok) {
    const text = await r.text().catch(() => '');
    throw new Error(`HTTP ${r.status}: ${text || r.statusText}`);
  }
  return r.json();
}

export async function getEntitlements() {
  const nonce = await getNonce();
  console.log(nonce);
  return fetchJSON('/wp-json/grade/v1/entitlements', { nonce });
}
